import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

type RebateEnrollmentColumn =
  | 'tradespend_user_name'
  | 'tradespend_user_email'
  | 'company_name'
  | 'attribution_code'
  | 'status'
  | 'total_claims'
  | 'pending_validation_claims'
  | 'invalid_claims'
  | 'unpaid_valid_claims'
  | 'paid_claims'
  | 'total_validated_units'
  | 'total_validated_payout'
  | 'created'

export const REBATE_ENROLLMENT_COLUMNS: Record<
  RebateEnrollmentColumn,
  DataTypeColumn
> = {
  tradespend_user_name: {
    header: 'Name',
    group: 'User Information',
  },
  tradespend_user_email: {
    header: 'Email',
    group: 'User Information',
  },
  company_name: {
    header: 'Company',
    group: 'User Information',
  },
  attribution_code: {
    header: 'Attribution Code',
    group: 'User Information',
  },
  status: {
    header: 'Status',
    group: 'Status',
  },
  total_claims: {
    header: 'Total Claims',
    group: 'Claims',
  },
  pending_validation_claims: {
    header: 'Claims Pending Validation',
    group: 'Claims',
  },
  invalid_claims: {
    header: 'Invalid Claims',
    group: 'Claims',
  },
  unpaid_valid_claims: {
    header: 'Unpaid Valid Claims',
    group: 'Claims',
  },
  paid_claims: {
    header: 'Paid Valid Claims',
    group: 'Claims',
  },
  total_validated_units: {
    header: 'Total Valid Units',
    group: 'Validated Data',
  },
  total_validated_payout: {
    header: 'Total Valid Payout',
    group: 'Validated Data',
  },
  created: {
    header: 'Date',
    group: 'Date',
  },
}
